<template>
  <div>
    <rum-content-tree class="content__tree" :categories="categories" :priorities="priorities" @priority="updatePriority" />

    <div class="add__partner" style="margin-bottom: 90px;">
      <div class="add__partner-section">
        <div class="add__partner-text">Always include Bytes from these Content Partners:
          <i class="tooltip-icon fas fa-question-circle" v-tooltip="'These Bytes will always be featured and included in your Project.'"></i>
        </div>
        <div class="partner__add-container">
          <rum-select
            placeholder="Please Select a partner"
            v-model="selectedPartner"
            :options="filteredOrganizationPartners"
            :clearable="false"
            class="partners__filter"
            label="name"
          />
          <rum-button class="partner__add-button" @click="addPrioritizedPartner">Add Partner</rum-button>
        </div>
      </div>
      <rum-loader full v-if="working" style="height: 75px"/>
      <div v-else-if="prioritizedPartnersProject.length <= 0" class="project__empty">
        There are no Partners available.
      </div>
      <div v-else class="project__container">
        <table class="project__table">
          <thead>
            <tr class="project-table__row">
              <th>Partner Name</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr class="project-table__data" v-for="(partner, index) in prioritizedPartnersProject" :key="index">
              <td style="min-width: 125px; color: var(--black)">{{partner.organization.name}}</td>
              <td>
                <div class="project__action" @click="viewOrganizationBytes(partner)">
                  <i class="far fa-eye project-action__item"></i>
                  <span class="project-action__label">View org bytes</span>
                </div>
              </td>
              <td>
                <div class="project__action" @click="confirmPartnerDelete(partner)">
                  <i class="far fa-trash-alt project-action__item"></i>
                  <span class="project-action__label">Delete</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "ProjectLearningContent",
  data() {
    return {
      priorities: {},
      categories: [],
      selectedPartner: null,
      working: false,
      prioritizedPartners: [],
      prioritizedPartnersProject: [],
      organizationByte: {}
    };
  },
  computed: {
    organizationPartners() {
      return this.$store.getters.administeredOrganizations;
    },
    projectId() {
      return this.$route.params.id;
    },
    filteredOrganizationPartners() {
      const prioritizedPartnerIds = this.prioritizedPartnersProject.map(p => p.org_id);
      return this.prioritizedPartners.filter(p => !prioritizedPartnerIds.includes(p.id));
    }
  },
  methods: {
    async fetchCategories() {
      const current = api('v3');
      this.loading = true;
      const { data } = await current.get(`connect/projects/${this.projectId}/categories`);
      this.categories = data || [];
      for (let category of this.categories) {
        this.priorities[category.id] = category.priority;
        for (let topic of category.topics) {
          this.priorities[topic.id] = topic.priority;
          for (let theme of topic.themes) {
            this.priorities[theme.id] = theme.priority;
          }
        }
      }
    },
    async updatePriority(data) {
      const priorities = {};
      priorities[data.id] = data.priority;
      this.priorities = { ...this.priorities, ...priorities };


      try {
        const current = api('v3');
        await current.post(`connect/projects/${this.projectId}/content_entities/${data.id}`, {
          priority: data.priority,
          entity: data.type,
        });
        this.$notify({
          type: "success",
          title: "Your Category selection has been saved."
        });
      } catch (error) {
      const errorMessage = error.response.data.message;
      this.$notify({
        type: "error",
        title: errorMessage || "Failed to update Entity, please try again."
      });
      }
    },
    async addPrioritizedPartner() {
      try {
        this.working = true;
        const current = api('v3');
        await current.post(`connect/projects/${this.projectId}/prioritized_partners`, {
          org_id: this.selectedPartner.id
        });
        this.$notify({
          type: "success",
          title: "Successfully Added Prioritized Partner"
        });
      } catch (error) {
        console.log(error);
        const errorMessage = error.response.data.message;
        this.$notify({
          type: "error",
          title: errorMessage || "Failed to add partner, please try again."
        });
      } finally {
        this.working = false;
        this.selectedPartner = [];
        this.getPrioritizedPartnersProject();
      }
    },
    async getPrioritizedPartners() {
      const current = api('v3');
      this.working = true;
      const { data } = await current.get(`/connect/organizations/list`);
      this.prioritizedPartners = data || [];
      this.working = false;
    },
    async getPrioritizedPartnersProject() {
      const current = api('v3');
      this.working = true;
      const { data } = await current.get(`/connect/projects/${this.projectId}/prioritized_partners`);
      this.prioritizedPartnersProject = data || [];
      this.$store.dispatch("projectEdit/partnerAvailableStatus", this.prioritizedPartnersProject);
      this.working = false;
    },
    async listOrganizationProjects() {
      const current = api('v3');
      const { data } = await current.get(`connect/organizations/list`);
      this.organizationPartners = data || [];
    },
    async confirmPartnerDelete(partner) {
      this.$modal.show("dialog", {
        title: "Delete Server",
        text: `Are you sure you want to delete Partner ${partner.organization.name}?`,
        buttons: [
          {
            title: "Yes",
            handler: async () => {
              try {
                this.working = true;
                const current  = api('v3');
                await current.delete(`connect/projects/${this.projectId}/prioritized_partners/${partner.id}`);
                this.$notify({
                  type: "success",
                  title: "Partner has deleted successfully."
                });
                this.$modal.hide("dialog");
              }
              catch(error) {
                  console.log(error);
                  const errorMessage = error.response.data.message;
                  this.$notify({
                  type: "error",
                  title: errorMessage || "Failed to delete Partner."
                });
              } finally {
                this.working = false;
                this.getPrioritizedPartnersProject();
              }
            }
          },
          {
            title: "No",
            handler: () => this.$modal.hide("dialog")
          }
        ]
      });
    },
    viewOrganizationBytes(partner) {
      if(process.env.NODE_ENV === 'production') {
        window.open(`http://build.rumie.org/organization/${partner.organization.firebase_id}/bytes`, "_blank");
      } else {
        window.open(`http://bytebuilder-staging.rumie.org/organization/${partner.organization.firebase_id}/bytes`, "_blank");
      }
    }
  },
  mounted() {
    this.fetchCategories();
    this.getPrioritizedPartnersProject();
    this.getPrioritizedPartners();
  }
};
</script>

<style scoped>
.content__tree, .add__partner {
  height: 100%;
  background: var(--white);
  margin: var(--spacing-4);
}

.add__partner-section {
  padding: var(--spacing-4);
}

.add__partner-text {
  font-size: var(--md);
  line-height: var(--spacing-5);
  color: var(--grey-darkest)
}

.partner__add-container {
  display: flex;
  justify-content: space-between;
  margin-top: var(--spacing-4);
}

.partners__filter {
  width: 100%;
}

.partner__add-button {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--spacing-3) var(--spacing-6) !important;
  font-size: var(--sm) !important;
  margin-left: 15px;
}

.project__empty {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--base);
  color: var(--grey);
  background: var(--white);
  height: 100%;
  text-align: center;
  padding: var(--spacing-8);
  margin: 0 var(--spacing-4);
}

.project__table {
  border-collapse: collapse;
  width: 100%;
}

.project__container {
  overflow-x: auto;
  background-color: var(--white);
  margin-top: var(--spacing-4);
}

th {
  padding: var(--spacing-3) var(--spacing-4);
  font-size: var(--xs);
  text-align: left;
  color: var(--grey-dark);
}

td {
  padding: var(--spacing-3) var(--spacing-4);
  font-size: var(--sm);
  text-align: left;
  color: var(--grey-dark);
}

.project-table__row {
  background: var(--grey-lighter);
}

.project-table__data {
  border-bottom: var(--border-1) solid var(--grey-lighter);
}

.project-table__data:last-child {
  border-bottom: none;
}

.project__action {
  display: flex;
  align-items: center;
  color: var(--primary);
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: none;
}

.project__action:disabled {
  opacity: var(--opacity-50);
  cursor: not-allowed;
}

.project-action__item {
  font-size: var(--base);
}

.project-action__label {
  font-weight: 600;
  margin-left: var(--spacing-2);
  min-width: 100px;
}

@media screen and (max-width: 500px) {
  .partner__add-container {
    flex-direction: column;
  }

  .partner__add-button {
    margin-left: 0;
    margin-top: var(--spacing-4);
  }
}
</style>
